module.exports = __webpack_public_path__ + "static/img/applicableScene1.56a1087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene1.png
// module id = ZUzS
// module chunks = 1